<template>
    <div class="mb-4">
        {{ translate("Select Genres") }}

        <div class="form-group mt-4 row">
            <div class="col-xl-12 dm-checkbox-email-options checkbox-list">
                <label
                    class="checkbox"
                    v-for="taxonomy in genres"
                    :key="'taxonomy-' + taxonomy.id"
                >
                    <input
                        type="checkbox"
                        :value="taxonomy.id"
                        v-model="submission.genres_ids"
                        @change="saveSubmission()"
                    />
                    <span></span>{{ taxonomy.name }}
                </label>
            </div>
        </div>
    </div>

    <!-- v-if="submission.category_id == 1" / Adult Fiction -->
    <div class="mb-8">
        {{ translate("Other Genres") }}
        <input
            class="form-control dm-other-genres"
            v-model="submission.other_genres"
            @change="saveSubmission()"
        />
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapActions, mapWritableState } from "pinia";

export default {
    props: ["genres"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),
    },
};
</script>
